module.exports = __webpack_public_path__ + "static/img/scout2.c43557f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/scout2.png
// module id = YiUy
// module chunks = 0